import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment.dev';
import * as flatData from '../../fake-db/data/flat.json';
import * as contactUsData from '../../fake-db/data/contact-us.json';
import * as homeData from '../../fake-db/data/home.json';
import * as aboutUsData from '../../fake-db/data/about-us.json';
import * as shoppersData from '../../fake-db/data/shoppers.json';
import * as sellersData from '../../fake-db/data/sellers.json';
import * as partnersData from '../../fake-db/data/partners.json';
import * as blogsData from '../../fake-db/data/blogs.json';
import * as privacyPolicyData from '../../fake-db/data/privacy-policy.json';
import * as termsOfServiceData from '../../fake-db/data/terms-of-service.json';

@Injectable()
export class DataService {
  getPageUrl(url: string) {
    let page;
    let blog_slug;

    page = (url === '/') ? 'home' : url.includes('/blogs/') ? 'single-blog' : url.trim().slice(1); 
    blog_slug = (page === 'single-blog') ? url.trim().slice(7) : '';

    switch ( page ) {
      case 'about-us':
        return `${environment.BACKEND_HOST}/api/about-us/`;
      case 'blogs':
        return `${environment.BACKEND_HOST}/api/blogs/`;
      case 'contact-us':
        return `${environment.BACKEND_HOST}/api/contact-us/`;
      case 'home': 
        return `${environment.BACKEND_HOST}/api/home/`;
      case 'partners':
        return `${environment.BACKEND_HOST}/api/partners/`;
      case 'sellers':
        return `${environment.BACKEND_HOST}/api/sellers/`;
      case 'shoppers':
        return `${environment.BACKEND_HOST}/api/shoppers/`;
      case 'single-blog':
        return `${environment.BACKEND_HOST}/api/single-blog/${blog_slug}/`;
      case 'privacy-policy':
        return `${environment.BACKEND_HOST}/api/privacy-policy/`;
      case 'terms-of-service':
        return `${environment.BACKEND_HOST}/api/terms-of-service/`;
      default:
        return `${environment.BACKEND_HOST}/api/general-info/flat/`;
    }
  }

  /* Fake Data Handling */
  getPageInfo(url: string) {
    let page;
    page = (url === '/') ? 'home' : url.includes('/blogs/') ? 'single-blog' : url.trim().slice(1); 

    switch ( page ) {
      case 'about-us':
        return aboutUsData;
      case 'blogs':
        return blogsData;
      case 'contact-us':
        return contactUsData;
      case 'home': 
        return homeData;
      case 'partners':
        return partnersData;
      case 'sellers':
        return sellersData;
      case 'shoppers':
        return shoppersData;
      case 'single-blog':
        return {};
      case 'privacy-policy':
        return privacyPolicyData;
      case 'terms-of-service':
        return termsOfServiceData;
      default:
        return flatData;
    }
  }
}
